import { useUser } from "contexts";
import { createContext, useContext } from "react";
import { useFetchCharactersByIds } from "services/characters";

const Characters = createContext();

export function CharactersProvider({ children }) {
  const { profile } = useUser();

  const ids = profile.characterIds;
  const characters = useFetchCharactersByIds(ids);

  return (
    <Characters.Provider value={characters}>{children}</Characters.Provider>
  );
}

export const useCharacters = () => useContext(Characters);
